// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4c648bce","453":"8c7525d7","732":"bea40cfb"}[chunkId] + ".chunk.js";
};